// UserProfile.js
import React, { useEffect, useRef, useState } from "react";
import PageHeading from "../../components/pageHeading/PageHeading";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import UserProfileSidebar from "./userProfileSidebar/UserProfileSidebar";
import AccountSetting from "./accountSetting/AccountSetting";
import "./userProfile.scss";
import { provider_getProfile } from "../../services/auth.service";
import { setLoader, isLoading } from "../../slice/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { CiCircleInfo } from "react-icons/ci";
const UserProfile = () => {
  // Ref for the container element to scroll
  const isLoading1 = useSelector(isLoading);
  const containerRef = useRef(null);
  const [providerData, setProviderData] = useState();
  const dispatch = useDispatch();
  // Function to scroll to a specific section based on the ID
  const scrollToSection = (sectionId) => {
    const sectionElement = document.getElementById(sectionId);
    if (sectionElement) {
      const targetScrollY =
        sectionId === "account-setting"
          ? sectionElement.offsetTop - 400
          : sectionElement.offsetTop - 150;
      window.scrollTo({
        top: targetScrollY,
        behavior: "smooth",
      });
    }
  };

  const fetchProfileData = async () => {
    await dispatch(setLoader(true));
    try {
      const response = await provider_getProfile();

      setProviderData(response?.data);

      await dispatch(setLoader(false));
    } catch (error) {
      await dispatch(setLoader(false));
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  function generateInfoText() {
    let infoText = "";
    let needComma = false; // Flag to track if comma is needed

    if (
      providerData?.provider?.marketingEmail === null &&
      !providerData?.policyText
    ) {
      infoText += (needComma ? ", " : "") + "cancellation policy provisions";
      needComma = true; // Set flag to true since we added a detail
    }
    if (
      providerData?.provider?.marketingEmail === null &&
      !providerData?.bankDetails
    ) {
      infoText += (needComma ? ", " : "") + "bank details";
      needComma = true;
    }
    if (providerData?.provider?.bio === "" || !providerData?.provider?.bio) {
      infoText += (needComma ? ", " : "") + "completed biography";
      needComma = true;
    }
    if (
      providerData?.provider?.location === "" ||
      !providerData?.provider?.location
    ) {
      infoText += (needComma ? ", " : "") + "location";
      needComma = true;
    }
    return infoText;
  }

  return (
    <>
      <Header />
      {!isLoading1 ? (
        <div>
          {!providerData?.provider?.bio ||
          providerData?.provider?.bio === " " ||
          (providerData?.provider?.marketingEmail === null &&
            (providerData?.bankDetails === " " ||
              !providerData?.bankDetails)) ||
          !providerData?.policyText ||
          !providerData?.provider?.location ? (
            <>
              <div className="info-icon-container">
                <div className="sub-info-container">
                  <div className="info-icon-left">
                    <CiCircleInfo size={35} />
                  </div>
                  <div className="info-icon-right">
                    <span>
                      Please, Finish your provider profile set up and add{" "}
                      {generateInfoText()}
                    </span>
                  </div>
                </div>
              </div>
             
            </>
          ) : null}
        </div>
      ) : null}
      <PageHeading title="User Profile" />
      <div className="main-container">
        <div className="container-wrap">
          <div className="user-profile-container" ref={containerRef}>
            {/* Pass scrollToSection as a prop to UserProfileSidebar */}
            <UserProfileSidebar scrollToSection={scrollToSection} />
            {/* Pass the containerRef as a prop to AccountSetting */}
            <AccountSetting fetchProfileData={fetchProfileData} />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserProfile;
